import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Table from "../shared/table/Table";
import { FiEye, FiEdit3, FiTrash2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BrandTable = () => {
  const [rows, setRows] = useState([]);
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  const fetchData = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/stock-brands/list`,
    );
    setRows(res.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  //  SWITCH Component (status toggle)
  const StatusSwitch = ({ id, current }) => {
    const [checked, setChecked] = useState(current === "aktif");

    const toggle = async () => {
      const newStatus = checked ? "pasif" : "aktif";
      setChecked(!checked);

      try {
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/api/stock-brands/${id}`,
          { status: newStatus },
        );
        toast.success("Durum güncellendi");
        fetchData();
      } catch (err) {
        toast.error("Durum güncellenemedi");
        setChecked(checked);
      }
    };

    return (
      <div className="form-check form-switch text-center">
        <input
          className="form-check-input"
          type="checkbox"
          checked={checked}
          onChange={toggle}
          style={{ cursor: "pointer", width: 45, height: 22 }}
        />
      </div>
    );
  };

  const handleDelete = (id) => {
    confirmAlert({
  title: getText("DESTROY_CONFIRM_TITLE"),
      message: getText("DESTROY_CONFIRM_MSG"),
      buttons: [
        {
          label: getText("YES_DELETE"),
          onClick: async () => {
            try {
              await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/stock-brands/${id}`,
              );
             toast.success(getText("SUCCESS_DELETED"));
              fetchData();
            } catch {
             toast.error(getText("ERROR_DELETE_FAILED"));
            }
          },
        },
        { label: getText("CANCEL")},
      ],
    });
  };

  const columns = useMemo(
    () => [
      { accessorKey: "id", header: getText("TABLE_ID_LABEL"), size: 60 },
      {
        accessorKey: "image",
        header: getText("TABLE_LOGO_LABEL"),
        cell: (info) => {
          const src = info.getValue();
          if (!src) return "-";
          return (
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}${src}`}
              alt=""
              style={{
                width: 60,
                height: 60,
                objectFit: "contain",
                borderRadius: 6,
              }}
            />
          );
        },
      },
      
      { accessorKey: "title", header: getText("TABLE_TITLE_LABEL") },

      //  Durum Switch
      {
        accessorKey: "status",
        header: getText("TABLE_STATUS_LABEL"),
        cell: (info) => (
          <StatusSwitch id={info.row.original.id} current={info.getValue()} />
        ),
        size: 150,
      },

      // Tarih
      {
        accessorKey: "created_at",
        header: getText("TABLE_DATE_LABEL"),
        cell: (info) =>
          info.getValue()
            ? new Date(info.getValue()).toLocaleDateString("tr-TR")
            : "-",
      },

      // Actions
      {
        accessorKey: "actions",
        header: getText("TABLE_ACTIONS_LABEL"),
        cell: (info) => {
          const id = info.row.original.id;
          return (
            <div className="d-flex gap-2">
              <Link
                to={`/brands/view/${id}`}
                className="avatar-text avatar-md text-primary bg-soft-primary border-soft-primary"
                 title={getText("VIEW")}
              >
                <FiEye />
              </Link>
              <Link
                to={`/brands/edit/${id}`}
                className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
                 title={getText("EDIT")}
              >
                <FiEdit3 />
              </Link>
              <button
                onClick={() => handleDelete(id)}
                className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
                 title={getText("DELETE")}
              >
                <FiTrash2 />
              </button>
            </div>
          );
        },
      },
    ],
     [translations],
  );

  return <Table data={rows} columns={columns} />;
};

export default BrandTable;
